import React, { useEffect, useState } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import Select from "react-select";
import Swal from "sweetalert2";

import { getAllPaciente } from "../../../../api/pacienteApi";
import { getAllUsuario } from "../../../../api/usuarioApi";

const initialForm = {
  idPaciente: "",
  paciente: "",
  idUsuario: "",
  usuario: "",
  fechaInicio: "",
  fechafin: "",
  horainicio: "",
  horafin: "",
  totalhs: "",
  tarifa: "",
  honorario: "",
  paraTarifa: false,
  paraHonorario: false,
  idliquidacion: "",
};

const ModalAddMarcacion = ({ estado, onCloseModal, onReturnValue }) => {
  const [form, setForm] = useState(initialForm);

  const [pacientes, setPacientes] = useState([]);
  const [usuarios, setUsuarios] = useState([]);

  const [loadingPacientes, setLoadingPacientes] = useState(false);
  const [loadingUsuarios, setLoadingUsuarios] = useState(false);

  /* =========================
     CARGAR DATOS
  ========================= */
  useEffect(() => {
    cargarDatos();
  }, []);

  const cargarDatos = async () => {
    try {
      setLoadingPacientes(true);
      setLoadingUsuarios(true);

      const p = await getAllPaciente();
      const u = await getAllUsuario();

      setPacientes(
        p.map((x) => ({
          value: x.IdPacientes,
          label: x.NombrePaciente,
        }))
      );

      setUsuarios(
        u.map((x) => ({
          value: x.IdUsuario,
          label: x.Nombre,
        }))
      );
    } catch (err) {
      Swal.fire("Error", err.message, "error");
    } finally {
      setLoadingPacientes(false);
      setLoadingUsuarios(false);
    }
  };

  /* =========================
     AUTO CÁLCULO TOTAL HS
  ========================= */
  useEffect(() => {
    const {
      fechaInicio,
      fechafin,
      horainicio,
      horafin,
    } = form;

    if (!fechaInicio || !fechafin || !horainicio || !horafin) {
      setForm((prev) => ({ ...prev, totalhs: "" }));
      return;
    }

    const inicio = new Date(`${fechaInicio}T${horainicio}`);
    const fin = new Date(`${fechafin}T${horafin}`);

    if (fin <= inicio) {
      setForm((prev) => ({ ...prev, totalhs: "" }));
      return;
    }

    const diffMs = fin - inicio;
    const horas = diffMs / (1000 * 60 * 60);

    setForm((prev) => ({
      ...prev,
      totalhs: horas.toFixed(2),
    }));
  }, [
    form.fechaInicio,
    form.fechafin,
    form.horainicio,
    form.horafin,
  ]);

  /* =========================
     HANDLERS
  ========================= */
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handlePacienteSelect = (option) => {
    if (!option) {
      setForm((prev) => ({ ...prev, idPaciente: "", paciente: "" }));
      return;
    }
    setForm((prev) => ({
      ...prev,
      idPaciente: option.value,
      paciente: option.label,
    }));
  };

  const handleUsuarioSelect = (option) => {
    if (!option) {
      setForm((prev) => ({ ...prev, idUsuario: "", usuario: "" }));
      return;
    }
    setForm((prev) => ({
      ...prev,
      idUsuario: option.value,
      usuario: option.label,
    }));
  };

  const handleSubmit = () => {
    if (!form.idPaciente || !form.idUsuario) {
      Swal.fire("Atención", "Debe seleccionar paciente y usuario", "warning");
      return;
    }

    if (!form.totalhs) {
      Swal.fire("Atención", "El rango horario no es válido", "warning");
      return;
    }

    onReturnValue(form);
  };

  /* =========================
     RENDER
  ========================= */
  return (
    <Modal show={estado} onHide={onCloseModal} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>➕ Agregar Marcación</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form>
          <Row className="gy-3">

            <Col md={6}>
              <Form.Label>Usuario del serv.</Form.Label>
              <Select
                options={pacientes}
                isClearable
                isSearchable
                isLoading={loadingPacientes}
                placeholder="Buscar Usuario..."
                onChange={handlePacienteSelect}
              />
            </Col>

            <Col md={6}>
              <Form.Label>Profesional</Form.Label>
              <Select
                options={usuarios}
                isClearable
                isSearchable
                isLoading={loadingUsuarios}
                placeholder="Buscar profesional..."
                onChange={handleUsuarioSelect}
              />
            </Col>

            <Col md={6}>
              <Form.Label>Fecha inicio</Form.Label>
              <Form.Control
                type="date"
                name="fechaInicio"
                value={form.fechaInicio}
                onChange={handleChange}
              />
            </Col>

            <Col md={6}>
              <Form.Label>Fecha fin</Form.Label>
              <Form.Control
                type="date"
                name="fechafin"
                value={form.fechafin}
                onChange={handleChange}
              />
            </Col>

            <Col md={6}>
              <Form.Label>Hora inicio</Form.Label>
              <Form.Control
                type="time"
                name="horainicio"
                value={form.horainicio}
                onChange={handleChange}
              />
            </Col>

            <Col md={6}>
              <Form.Label>Hora fin</Form.Label>
              <Form.Control
                type="time"
                name="horafin"
                value={form.horafin}
                onChange={handleChange}
              />
            </Col>

            <Col md={4}>
              <Form.Label>Total horas</Form.Label>
              <Form.Control
                name="totalhs"
                value={form.totalhs}
                readOnly
              />
            </Col>

            <Col md={4}>
              <Form.Label>Tarifa</Form.Label>
              <Form.Control
                name="tarifa"
                value={form.tarifa}
                onChange={handleChange}
              />
            </Col>

            <Col md={4}>
              <Form.Label>Honorario</Form.Label>
              <Form.Control
                name="honorario"
                value={form.honorario}
                onChange={handleChange}
              />
            </Col>

            <Col md={6}>
              <Form.Check
                type="checkbox"
                label="Para tarifa"
                name="paraTarifa"
                checked={form.paraTarifa}
                onChange={handleChange}
              />
            </Col>

            <Col md={6}>
              <Form.Check
                type="checkbox"
                label="Para honorario"
                name="paraHonorario"
                checked={form.paraHonorario}
                onChange={handleChange}
              />
            </Col>

            <Col md={12}>
              <Form.Label>ID Liquidación</Form.Label>
              <Form.Control
                name="idliquidacion"
                value={form.idliquidacion}
                onChange={handleChange}
              />
            </Col>

          </Row>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="danger" onClick={onCloseModal}>
          Cancelar
        </Button>
        <Button variant="primary" onClick={handleSubmit}>
          Guardar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalAddMarcacion;
